import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { RevealOnScroll } from './MotionComponents';

export default function FinalCTA() {
  const navigate = useNavigate();

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="bg-[#00163E] py-32 md:py-40 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[#00163E] to-[#001F4F]" />
      <div className="grain absolute inset-0" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <RevealOnScroll>
          <p
            data-testid="final-cta-question"
            className="text-2xl sm:text-3xl md:text-4xl font-normal tracking-[0.01em] leading-snug text-white mb-16 md:mb-20"
          >
            ¿Busca experiencia para una decisión importante o quiere poner su experiencia al servicio de otras empresas?
          </p>
        </RevealOnScroll>

        <RevealOnScroll delay={0.2}>
          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <button
              onClick={() => navigate('/empresa')}
              data-testid="final-cta-empresa"
              className="group flex items-center justify-center gap-3 bg-[#C58C40] text-white hover:bg-[#b07b35] transition-colors duration-300 rounded-sm px-10 py-4 text-sm tracking-[0.15em] uppercase"
            >
              <span>Soy Empresa</span>
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              onClick={() => navigate('/advisor')}
              data-testid="final-cta-advisor"
              className="group flex items-center justify-center gap-3 bg-transparent border border-white/20 text-white hover:bg-white/5 transition-colors duration-300 rounded-sm px-10 py-4 text-sm tracking-[0.15em] uppercase"
            >
              <span>Soy Advisor</span>
              <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
}
